import { SiteItemData } from "../../../../interfaces";
import { isWcmEditor } from "../../../../../config/serverConfig";
import { VideoGalleryVerticalDesktop } from "./videoGalleryVerticalDesktop";

export interface categoryObj {
    id: string
    categoryColor: string
    name:string
}

interface VideoGalleryVerticalComponentaProps {
    videoList: SiteItemData[]
    isTabVisible: boolean
    tabTitleText: string
    repeatAds: number
    maxAds: number
    firstAdPlace: number
    category: categoryObj
    domain: string
}

export class VideoGalleryVerticalAutoComponenta extends React.Component<VideoGalleryVerticalComponentaProps, {}>{
    public static siteScriptName = "RadionasVideoGalleryVerticalAutoComponenta";

    public render() {
        const { videoList, isTabVisible, tabTitleText, repeatAds, maxAds, firstAdPlace, category, domain } = this.props;
        const componentClass = `radionasVideoGalleryVerticalAutoComponenta ${isWcmEditor() ? "editMode" : ""}`;

        return (
            <div className={componentClass}>
                <VideoGalleryVerticalDesktop
                    videoList={videoList}
                    isTabVisible={isTabVisible}
                    tabTitleText={tabTitleText}
                    repeatAds={repeatAds}
                    maxAds={maxAds}
                    firstAdPlace={firstAdPlace}
                    category={category}
                    domain={domain}/>
            </div>
        )
    }
}
